import { Signal } from "signals";
import Layers from "slotworks/graphics/layers/layers";
import settingsModel from "slotworks/model/settings/settings-model";
import BonusRecord from "integration/revolver/schema/bonus-record";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import { parallel } from "slotworks/utils/race-utils";
import * as TweenJS from "slotworks/utils/tween";
import Wheel from "./wheel";
import Contract from "slotworks/utils/contract";
import soundManager from "slotworks/sound/sound-manager";
import { CenterPivot } from "slotworks/graphics/pixi/group";
import gameState from "slotworks/model/game-state";
import DSComponents from "components/components";
import betModel from "slotworks/model/bets/bet-model";

export default class BonusWheelComponent {

    public onTriggered: Signal = new Signal();
    public onComplete: Signal = new Signal();
    private multiplier: number;

    private wheel: Wheel;
    private hand: PIXI.Sprite;
    private totalWin: number;

    private value: PIXI.extras.BitmapText;

    public enterBonus(multiplier: number = 1) {
        this.multiplier = multiplier;
        const scene = "BonusWheel" + multiplier;

        const finish = () => {
            this.onComplete.dispatch(this.totalWin);
        };
        const ready = () => this.waitForInput();
        this.setup(scene).then(() => {
            this.hand = Layers.BonusForeground.getSprite("hand_icon");
            this.hand.visible = false;
            this.value = Layers.BonusForeground.getBitmapText("value");
            this.value.visible = false;
            // probably better this part to be in the record or in the engine itself, temporary
            const jackpot = DSComponents.jackpotMeter.getValue(betModel.getTotalBet());
            this.wheel = new Wheel(multiplier, jackpot * multiplier);
            this.wheel.onComplete.addOnce(finish);
            this.wheel.onReady.addOnce(ready);
        });
    }

    // todo celebration layers
    private setup(scene: string) {
        Layers.CelebrationBackground.moveBehind(Layers.Bonus);
        return new Contract<void>(resolve => {
            parallel([
                () => Layers.BonusForeground.setScene("BonusWheel"),
                () => Layers.Bonus.setScene(scene)
            ]).then(() => resolve(null));
        });
    }

    // todo temporary
    public waitForInput() {
        const onKeyDown = (event: any) => {
            if (settingsModel.getSpaceToSpin()) {
                if (event.keyCode === 32) {
                    onClick();
                }
            }
        };

        const onClick = () => {
            document.removeEventListener("keyup", onKeyDown);
            document.body.removeEventListener(ButtonEvent.POINTER_DOWN.getEventString(), onClick, true);
            Layers.Bonus.container.buttonMode = false;
            Layers.Bonus.container.interactive = false;
            TweenJS.removeAll(this.hand);
            this.hand.visible = false;
            soundManager.customEvent("bonus_wheel_spin_start");
            this.onTriggered.dispatch();
            this.wheel.start();
            soundManager.customEvent("bonus_wheel_spin_loop");
        };

        this.callToAction().then(() => {
            setTimeout(() => {
                document.addEventListener("keyup", onKeyDown);
                document.body.addEventListener(ButtonEvent.POINTER_DOWN.getEventString(), onClick, true);
                Layers.Bonus.container.on(ButtonEvent.POINTER_UP.getEventString(), onClick);
                Layers.Bonus.container.interactive = true;
                Layers.Bonus.container.buttonMode = true;
            }, 100);
        });
    }

    private callToAction(): Contract<void> {
        return new Contract<void>(resolve => {
            const start = Layers.BonusForeground.getPosition("hand_start");
            const end = Layers.BonusForeground.getPosition("hand_end");
            this.hand.visible = true;
            this.hand.position.set(start.x, start.y);
            new TweenJS.Tween(this.hand)
                .to({ y: end.y }, 800)
                .yoyo(true)
                .repeat(Infinity)
                .start();
            resolve(null);
        });
    }

    public feedResult(spinData: BonusRecord) {
        this.totalWin = spinData.creditsWon;
        this.wheel.setWinner(spinData.awardedMultiplier);
    }


    private animateTo(obj: any, props: any, duration: number, onComplete?: () => void) {
        const start = performance.now();
        const startProps = Object.keys(props).reduce((acc, key) => {
            acc[key] = obj[key];
            return acc;
        }, {} as any);

        const animate = (now: number) => {
            const progress = Math.min((now - start) / duration, 1);
            Object.keys(props).forEach(key => {
                obj[key] = startProps[key] + (props[key] - startProps[key]) * progress;
            });

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else if (onComplete) {
                onComplete();
            }
        };

        requestAnimationFrame(animate);
    }



    public exitBonus(): Contract<void> {
        return new Contract<void>(resolve => {
            this.wheel.clean();
            const record = gameState.getCurrentGame().latestRecord();
            let bonusRecord = record instanceof BonusRecord
                ? record as BonusRecord
                : gameState.getCurrentGame().getPreviousRecord() as BonusRecord;

            if (bonusRecord.isJackpotWon) {
                Layers.Bonus.defaultScene().then(() => {
                    parallel([
                        () => Layers.BonusForeground.defaultScene()
                    ]).then(() => resolve(null));
                });
            } else {
                resolve(null);
            }
        });
    }

}